import secureApi from '../../utils/secureApi';
import imageCompression from 'browser-image-compression';

export async function uploadBannerImage(file: File, contextType: 'main' | 'mobile' = 'main'): Promise<string> {
  // Compress the image (max 1MB, max 1920px)
  const compressedFile = await imageCompression(file, {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  });

  // Generate file name and context (sfl-banners/dd-mm-yy or sfl-banners/mobileView/dd-mm-yy)
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yyyy = now.getFullYear();
  const ext = compressedFile.type.split('/')[1] || 'jpg';
  const fileName = `banner_${Date.now()}.${ext}`;
  let context = '';
  if (contextType === 'main') {
    context = `sfl-banners/${dd}-${mm}-${yyyy}`;
  } else if (contextType === 'mobile') {
    context = `sfl-banners/mobileView/${dd}-${mm}-${yyyy}`;
  }

  // Get presigned URL
  const presignRes = await secureApi.post<any>(
    `/api/v1/general/presigned-url`,
    {
      fileName,
      contentType: compressedFile.type,
      context,
    }
  );

  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  const presignData = (presignRes as any)?.data || presignRes;
  const presignedUrl = presignData?.presignedUrl;
  const s3Key = presignData?.key;
  if (!presignedUrl || !s3Key) {
    throw new Error('Failed to get presigned URL');
  }

  // Upload to S3
  const uploadRes = await fetch(presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': compressedFile.type },
    body: compressedFile,
  });
  if (!uploadRes.ok) {
    throw new Error('Failed to upload image to S3');
  }

  // Return only the S3 key (not the full URL)
  return s3Key;
} 